(function() {
    setTimeout(function() {
        if(document.querySelector('[data-component="accordion"]')) {
            document.querySelectorAll('[data-component="accordion"]').forEach(function(accordionSet) {
                accordionSet.removeAttribute('role');
                accordionSet.removeAttribute('aria-multiselectable');
            });
            document.querySelectorAll('button[data-trigger-accordion]').forEach(function(accordion) {
                accordion.removeAttribute('role');
            });
        }
    }, 500)
})();
